module.exports = __webpack_public_path__ + "static/media/C013.cf1e5c9f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/carousel/C013.jpg
// module id = 296
// module chunks = 0